export const faqsCommon = [
  {
    q_it: "Quanto costa la ricerca perdite?",
    q_en: "How much does leak detection cost?",
    a_it: "Dipende dal tipo di ricerca e dalla complessità. Diamo sempre un preventivo chiaro prima di iniziare, senza sorprese. Spesso costa molto meno di una sostituzione 'a caso'.",
    a_en: "It depends on the type and complexity. We always give a clear quote before starting. Usually far cheaper than blind replacement.",
  },
  {
    q_it: "Davvero non rompete i muri?",
    q_en: "Do you really avoid breaking walls?",
    a_it: "Nella stragrande maggioranza dei casi facciamo solo un foro mirato di 5–10 cm. A volte un piccolo scavo. Mai una demolizione 'alla cieca'.",
    a_en: "In most cases we only make a targeted 5–10 cm hole. Sometimes a small dig. Never a blind demolition.",
  },
  {
    q_it: "Il gas tracciante è sicuro?",
    q_en: "Is tracer gas safe?",
    a_it: "Sì. Miscela 95% azoto + 5% idrogeno: non tossica, non infiammabile in quelle proporzioni e non altera il valore organolettico dell'acqua.",
    a_en: "Yes. 95% nitrogen + 5% hydrogen mix: non-toxic, non-flammable at that ratio, doesn't alter water taste.",
  },
  {
    q_it: "Intervenite anche di notte e nei festivi?",
    q_en: "Do you work nights and holidays?",
    a_it: "Sì, H24 sette giorni su sette. La perdita non aspetta, e noi nemmeno.",
    a_en: "Yes, 24/7 every day. Leaks don't wait, neither do we.",
  },
  {
    q_it: "In quanto tempo arrivate?",
    q_en: "How fast do you arrive?",
    a_it: "Cerchiamo di intervenire nel minor tempo possibile, in molte province in poche ore. Per emergenze gravi diamo priorità assoluta.",
    a_en: "As fast as possible, within hours in many provinces. Critical emergencies get top priority.",
  },
  {
    q_it: "Lavorate anche su condomini e attività commerciali?",
    q_en: "Do you work with condos and businesses?",
    a_it: "Sì, lavoriamo per privati, condomini, hotel, ospedali, capannoni e attività commerciali. Per gli antincendio rilasciamo report dedicati.",
    a_en: "Yes — private, condos, hotels, hospitals, warehouses, businesses. For fire systems we issue dedicated reports.",
  },
];
